import { FC, useMemo } from "react";
import TableComponent, {
  TableProps,
} from "../../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../context/app.context";
import OrderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableRow from "../types/order-optimizer-cargo-details-hidden-details-heading-tables-order-table-row";
import orderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableHelper from "./order-optimizer-cargo-details-hidden-details-heading-tables-order-table.helper";

type OrderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableProps = Pick<
  TableProps,
  "isError" | "isLoading"
>;

const OrderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableComponent: FC<
  OrderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow =
    (): OrderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableRow => {
      return {
        id: uuidService.generate(),
        value: {
          humanId: <div />,
          address: <div />,
          totalTime: <div />,
          haltingTime: <div />,
          distance: <div />,
        },
      };
    };

  const rows: OrderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableRow[] =
    useMemo(() => {
      const orderRows = createTableRow();

      return [orderRows];
    }, [selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
      onlyHeader
    />
  );
};

export default OrderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableComponent;
